import { Reducer } from "redux";
import {
  CustomerTopPageAction,
  CustomerTopPageActionType,
  ICallbackGetMeCustomerByTopPageAction,
} from "../action/customer_top_page_action";
import { CustomerTopPageState } from "../store/customer_top_page_state";

const initialState: CustomerTopPageState = {
  customer: null,
  jobCareers: [],
  pastCaseProjects: [],
  isLoading: false,
};

const customerTopPageReducer: Reducer<CustomerTopPageState> = (
  state = initialState,
  action: CustomerTopPageAction
): CustomerTopPageState => {
  switch (action.type) {
    case CustomerTopPageActionType.REQUEST_GET_ME_CUSTOMER_BY_TOP_PAGE: {
      return Object.assign({}, state, {
        customer: state.customer,
        jobCareers: state.jobCareers,
        pastCaseProjects: state.pastCaseProjects,
        isLoading: true,
      });
    }

    case CustomerTopPageActionType.CALLBACK_GET_ME_CUSTOMER_BY_TOP_PAGE: {
      const _action = action as ICallbackGetMeCustomerByTopPageAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          customer: _action.item ? _action.item.customer : null,
          jobCareers: _action.item ? _action.item.jobCareers : [],
          pastCaseProjects: _action.item ? _action.item.pastCaseProjects : [],
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          customer: state.customer,
          jobCareers: state.jobCareers,
          pastCaseProjects: state.pastCaseProjects,
          isLoading: false,
        });
      }
    }
    default:
      return state;
  }
};

export default customerTopPageReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_top_page_reducer.ts